import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Carousel} from "react-responsive-carousel";
import BASIEuropean from "../../components/Charts/BASI/BASIEuropean";

class OnTheMarketCharts extends Component {

    static propTypes = {
        // eslint-disable-next-line react/forbid-prop-types
        match: PropTypes.object.isRequired,
        // eslint-disable-next-line react/forbid-prop-types
        history: PropTypes.object.isRequired
    };

    shouldComponentUpdate(nextProps){
        const currentPath = this.props.history.location.pathname.replace(`/${this.props.match.params.id}`, '');
        const updatedPath = nextProps.history.location.pathname.replace(`/${nextProps.match.params.id}`, '');

        return currentPath !== updatedPath;
    }

    updateHistory = sliderNumber => {
        const {id} = this.props.match.params;
        if (sliderNumber === id) return;
        const url = this.props.match.path.replace(':id', sliderNumber);
        this.props.history.push(url);
    };

    render() {
        const {id} = this.props.match.params;

        return (
            <div>
                <h2 style={{textAlign: 'center'}}>Trax BASI</h2>
                <p>
                    Understand the true cost of your trades. Gauge activity by tracking volume weighted spreads in
                    selected U.S. Investment Grade segments, key sectors and specialty BASIs based on size, liquidity,
                    maturity and issuance.
                </p>
                <Carousel showArrows
                          showIndicators={false}
                          swipeable={false}
                          emulateTouch={false}
                          showThumbs={false}
                          showStatus={false}
                          onChange={this.updateHistory}
                          selectedItem={Number(id)}>
                    <BASIEuropean/>
                </Carousel>
                <p style={{fontSize: '12px'}}>
                    The Bid Ask Spread Index (the &quot;BASI Index&quot;) referred to herein and all information and data in
                    respect of such BASI Index are the proprietary material of MarketAxess, and are published on this
                    website for reference only. Any other use of the BASI Index is prohibited unless under the terms of
                    an express written license granted by MarketAxess. This prohibition includes but is not limited to
                    uses referred to in Article 3(1)(3) of EU Regulation 2016/1011 (the &quot;Benchmarks Regulation&quot;). This
                    notification serves to satisfy MarketAxess&#039;s obligations as an index-provider pursuant to Article
                    2(2)(h) of the Benchmarks Regulation. MarketAxess and each director, officer, employee,
                    representative, delegate and agent thereof hereby expressly disclaims, to the fullest extent
                    permitted by applicable law, any liability for any error, omission, interruption or delay relating
                    to the BASI Index as well as all warranties of accuracy, completeness, merchantability or fitness
                    for a particular purpose with respect to the BASI Index. MarketAxess shall not be under any
                    obligation to continue the calculation, publication and dissemination of the BASI Index and may
                    cease its calculation publication or dissemination at MarketAxess&#039;s discretion without notice.
                </p>
            </div>
        );
    }
}

export default OnTheMarketCharts;



// WEBPACK FOOTER //
// ./frontend/pages/Charts/TraxBASICharts.jsx